import cx from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Button(_ref) {
  let {
    size,
    className,
    variant,
    ...restProps
  } = _ref;
  const cn = cx('btn', className, {
    'btn-compact': size === 'compact',
    'btn-xs': size === 'xs',
    'btn-sm': size === 'sm',
    'btn-md': size === 'md',
    'btn-lg': size === 'lg',
    'btn-xl': size === 'xl',
    'btn-primary': variant === 'primary',
    'btn-secondary': variant === 'secondary',
    'btn-success': variant === 'success',
    'btn-danger': variant === 'danger',
    'btn-warning': variant === 'warning',
    'btn-info': variant === 'info',
    'btn-light': variant === 'light',
    'btn-dark': variant === 'dark',
    'btn-link': variant === 'link'
  });
  const props = {
    ...restProps
  };
  if (props.component === undefined || props.component === null) {
    props.component = 'button';
  }
  if (isAnchorProps(props)) {
    const {
      children,
      component: Component,
      ...p
    } = props;
    return /*#__PURE__*/_jsx(Component, {
      ...p,
      className: cn,
      children: children
    });
  } else if (isButtonProps(props) && props.component) {
    const {
      children,
      component: C,
      ...p
    } = props;
    return /*#__PURE__*/_jsx(C, {
      ...p,
      className: cn,
      children: children
    });
  }
  return null;
}
export function isAnchorProps(props) {
  return props.component === 'a';
}
export function isButtonProps(props) {
  return props.component === 'button';
}